export default {
  file_id: null,
  start_ms: 0,
  in_cut_ms: 0,
  duration_ms: 0,
};
